<template>
  <plantilla-contenido>
    <div slot="titulo">
      <i class="fas fa-home icon"></i>
      Inicio
    </div>
    <div slot="breadCrumb">
      <nav class="breadcrumb" aria-label="breadcrumbs">
        <ul>
          <li>
            <router-link :to="{ name: 'administratorReport' }">
              <span class="has-text-black">
                <i class="fas fa-home icon"></i>
                inicio
              </span>
            </router-link>
          </li>
          <li class="is-active">
            <router-link :to="{ name: 'administratorBeds' }">
              <span class="has-text-black">
                <i class="fas fa-bed"></i>
                Camas
              </span>
            </router-link>
          </li>
        </ul>
      </nav>
    </div>
    <div slot="contenido">
      <select-cat ref="SelectCategorization" :activeSelectStablishment="true"></select-cat>
      <br />
      <count-beds v-if="dataBeds.length !==0" :bed="dataBeds" ></count-beds>
      <br>
      <div class="field">
        <b-switch v-model="showBeds" :value="true" type="is-info">
          Ver en tabla
        </b-switch>
      </div>
      <div v-if="dataBeds.length !== 0">
        <table-beds v-if="showBeds" :listBeds="dataBeds"></table-beds>
        <beds-image v-else-if="!showBeds" :listBeds="dataBeds"></beds-image>
      </div>
    </div>
  </plantilla-contenido>
</template>
<script>
import { eventBus } from "../../../main";
import BedsImage from "../../../components/beds/BedsImage.vue";
import SelectCat from "../../../components/beds/SelectCat.vue";
import TableBeds from "../../../components/beds/TableBeds.vue";
import { BedFindByStablishmentSubCatIdNotEliminada } from "../../../services/beds";
import PlantillaContenido from "../../../template/PlantillaContenido.vue";
import CountBeds from '../../../components/beds/CountBeds.vue';
export default {
  components: {
    PlantillaContenido,
    TableBeds,
    SelectCat,
    BedsImage,
    CountBeds,
  },
  data() {
    return {
      showBeds: true,
      dataBeds: [],
    };
  },
  mounted() {
    this.chargeData();
    eventBus.$on("loadBedList", async () => {
      eventBus.$emit("rechargeTableBed",true);
      eventBus.$emit("rechargeBedImage",true);
      await this.chargeData();
      eventBus.$emit("rechargeTableBed",false);
      eventBus.$emit("rechargeBedImage",false);
    });
  },
  methods: {
    async chargeData() {            
      let subcat_id=this.$refs.SelectCategorization.subCategorization_id;
      let stablishment_id=this.$refs.SelectCategorization.stablishment_id;     
      this.dataBeds = await BedFindByStablishmentSubCatIdNotEliminada(this.$http,stablishment_id,subcat_id);
    },
  },
};
</script>